import { selectHipaaComplianceEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import { meSelector } from "../selectors";

import type { Subscription } from "@packages/client";

type Props = {
  projectId?: string;
  subscription?: Subscription;
};

export const useShowHipaa = ({ projectId, subscription }: Props): boolean => {
  const enableHipaaCompliance = useAppSelector(selectHipaaComplianceEnabled);
  const me = useAppSelector(meSelector);
  const project = me?.projects?.find(projectMe => projectMe.id === projectId);

  const hipaa = project?.hipaa || subscription?.hipaa;

  return Boolean(hipaa && enableHipaaCompliance);
};
